import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {LinkButtonNew} from '@components/common/base/buttons'
import {useGlobalKeyDown} from '@containers/hooks'
import {AddTaskError} from './add-task-error'
import {AddTaskStickers} from './add-task-stickers'
import {useAddTaskStore} from './add-task-store'

const TwContainer = tw.div`
  w-full
  pt-8
  pl-20
  space-y-8
`

const TwButtonsPanel = tw.div`
  flex
  gap-20
`

export const AddTaskWithRequiredStickers = observer(() => {
  const [, store] = useAddTaskStore()

  const onSubmit = (): void => {
    store.createTask({
      resetStickers: 'required'
    })
  }
  const onCancel = (): boolean => {
    store.reset({
      needClose: true,
      resetStickers: 'all',
      resetTemplateId: true
    })
    return true
  }

  useGlobalKeyDown({escape: onCancel})

  return (
    <TwContainer>
      <AddTaskStickers />

      <TwButtonsPanel>
        <LinkButtonNew color="secondary" size="sm" onMouseDown={onCancel}>
          {Lang.msg.cancel}
        </LinkButtonNew>
        <LinkButtonNew color="primary" size="md" onClick={onSubmit}>
          {Lang.msg.createTask}
        </LinkButtonNew>
      </TwButtonsPanel>

      <AddTaskError />
    </TwContainer>
  )
})
